import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgCopy = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      fillRule="evenodd"
      d="M6 1a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm-.5 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5z"
      clipRule="evenodd"
    />
    <path
      fill={_.color}
      d="M2.5 6.25a.75.75 0 0 0-1.5 0V13a2 2 0 0 0 2 2h6.75a.75.75 0 0 0 0-1.5H3a.5.5 0 0 1-.5-.5z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgCopy);
export default ForwardRef;
